const UsersIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    className={className}
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
    <circle cx="9.5" cy="7" r="3.2" />
    <path d="M20 21v-2a4 4 0 0 0-2.6-3.8" />
    <path d="M15.5 3.2a3.2 3.2 0 0 1 0 6.2" />
  </svg>
);

export default UsersIcon;
